import { Component } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { CrudPage } from '@zendra/shared';
import { GetGisRegisterInconsistenciesInputDto, GisRegisterInconsistencyCase } from 'orchestrator';
import { GisRegisterInconsistencyBase } from '../gis-register-inconsistency/gis-register-inconsistency-base';
import { GISREGISTERINCONSISTENCYONLYINGIS_CONFIG, GISREGISTERINCONSISTENCYONLYINGIS_FIELDS } from './gis-register-inconsistency-only-in-gis.config';

@Component({
  selector: 'lib-gis-register-inconsistency-only-in-gis',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class GisRegisterInconsistencyOnlyInGis extends GisRegisterInconsistencyBase {
  config = GISREGISTERINCONSISTENCYONLYINGIS_CONFIG;
  fields = GISREGISTERINCONSISTENCYONLYINGIS_FIELDS;

  protected override get caseFilter(): Partial<GetGisRegisterInconsistenciesInputDto> {
    return { case: GisRegisterInconsistencyCase.OnlyInGis };
  }

  protected getEntityName(): string {
    return 'GisRegisterInconsistencyOnlyInGis';
  }
}
